// landing-pages/src/services/configClient.ts
import dhyanaService from "./dhyanaService";
import { FALLBACK_PERSONAS } from "../config/fallback";

// Simple environment check - prefer process.env for broader compatibility
const USE_API = process.env.VITE_USE_API_CONFIG === "true";

export async function fetchPersonas() {
  if (!USE_API) {
    // Count feature flag disabled usage
    console.log("[ConfigClient] Using embedded personas (API disabled)");
    return FALLBACK_PERSONAS;
  }

  try {
    const config = await dhyanaService.loadConfig();
    console.log("[ConfigClient] Successfully fetched personas from API");
    return config.personas;
  } catch (e) {
    // Count fallback usage for monitoring
    console.warn(
      "[ConfigClient] API fetch failed, using fallback personas:",
      e,
    );
    console.log("[ConfigClient] Telemetry: persona_fetch_fallback", {
      error: e instanceof Error ? e.message : String(e),
      timestamp: new Date().toISOString(),
    });
    return FALLBACK_PERSONAS;
  }
}

export async function fetchStages(
  system: "hero14.v1" | "email5.v1" = "hero14.v1",
) {
  if (!USE_API) {
    console.log("[ConfigClient] Using empty stages (API disabled)");
    return {};
  }

  try {
    const config = await dhyanaService.loadConfig();
    console.log(
      `[ConfigClient] Successfully fetched ${system} stages from API`,
    );
    return config.stages;
  } catch (e) {
    console.warn(
      `[ConfigClient] ${system} stages fetch failed — returning empty object`,
      e,
    );
    console.log("[ConfigClient] Telemetry: stages_fetch_fallback", {
      system,
      error: e instanceof Error ? e.message : String(e),
      timestamp: new Date().toISOString(),
    });
    return {};
  }
}
